import React from "react";
import ButtonModal, { IButton } from "modal/ButtonModal/ButtonModal";

export default function FixedModal({
  title,
  sub,
  oneButton,
  twoRightButton,
  onClick,
}: {
  title: string;
  sub: string;
  oneButton: IButton;
  twoRightButton?: IButton;
  onClick: () => void;
}) {
  return (
    <>
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(0,0,0,0.4)",
          zIndex: "200",
        }}
        onClick={(e) => {
          e.stopPropagation();
          onClick();
        }}
      ></div>
      <div
        style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "300px",
          height: "200px",
          zIndex: "200",
        }}
        onClick={(e) => {
          e.stopPropagation();
          onClick();
        }}
      ></div>
      <ButtonModal
        title={title}
        sub={sub}
        oneButton={oneButton}
        twoRightButton={twoRightButton}
      />
    </>
  );
}
